import styled from 'styled-components';
import { Box } from '../../elements';

export const RentDetailsWrapper = styled(Box).attrs({
})`
  margin: 0.25rem 0;
  display: flex;
  justify-content: space-between;
`;
